import { addSelectedCalendarInStore } from '../actions/internalActions';
import { getSelectedCalendarsForMailbox } from '../selectors/getSelectedCalendarsForMailbox';
import { selectedCalendarsStore } from '../store/store';
import { dedupeArrayValues } from 'owa-selected-calendars-utils';
import { mutator } from 'satcheljs';

mutator(addSelectedCalendarInStore, actionMessage => {
    const { calendarId, primarySmtpAddress } = actionMessage;
    selectedCalendarsStore().selectedCalendars.set(
        primarySmtpAddress,
        dedupeArrayValues([...getSelectedCalendarsForMailbox(primarySmtpAddress), calendarId])
    );
});
